import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, apiErr } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    const isLink = new URLSearchParams(location.search).get("link_google") === "1";
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      if (isLink) {
        // Connecting Google to an already signed-in account (from Settings / Account panel).
        const dest = window.location.pathname.startsWith("/client") ? "/client" : "/settings";
        try {
          await api.post("/auth/google/link", {}, { headers: { "X-Session-ID": sessionId } });
          toast.success("Google connected");
        } catch (e) {
          toast.error(apiErr(e));
        }
        try { const { data: me } = await api.get("/auth/me"); setUser(me); } catch {}
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true });
        return;
      }
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        setUser(data);
        const home = data.role === "client" ? "/client" : "/dashboard";
        window.history.replaceState(null, "", home);
        navigate(home, { replace: true });
      } catch (e) {
        setError(apiErr(e) || "Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login"), 1800);
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a] text-white">
      <div className="font-mono text-sm tracking-widest uppercase animate-pulse">
        {error || "Authenticating…"}
      </div>
    </div>
  );
}
